import Icon from '../components/Icon.vue'

Icon.register({
  burn: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M192 0c111.8 100.9 192 220.6 192 300.5 0 124.5-79 211.5-192 211.5s-192-87-192-211.5c0-79.6 79.7-199.2 192-300.5zM192 448c56.5 0 96-39 96-94.8 0-13.5-4.6-61.5-96-161.2-91.4 99.7-96 147.7-96 161.2 0 55.8 39.5 94.8 96 94.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/burn.js
// module id = 1129
// module chunks = 0